
import Vue from 'vue';
import FileInput from '@/components/FileInput.vue';
import { api, AmazonExpenseCandidate, AmazonExpenseMatch, AmazonImportPreview, AmazonImportResult, AmazonRematchResult } from '@/services/api';
import { visualizeAmount } from '@/services/visualizer';
import { formatDate } from '@/services/date';

export default Vue.extend({
    components: {
        FileInput
    },
    data() {
        return {
            selectedFile: null as File | null,
            preview: null as AmazonImportPreview | null,
            result: null as AmazonImportResult | null,
            rematchResult: null as AmazonRematchResult | null
        }
    },
    methods: {
        async previewFile(file: File) {
            this.selectedFile = file;
            this.result = null;
            this.rematchResult = null;
            this.preview = await api.previewAmazonImport(file);
        },
        async persistImport() {
            if (!this.selectedFile) {
                return;
            }
            this.result = await api.importAmazonOrders(this.selectedFile);
            this.rematchResult = null;
            this.preview = await api.previewAmazonImport(this.selectedFile);
        },
        async rematchOrders() {
            this.result = null;
            this.rematchResult = await api.rematchAmazonOrders();
            if (this.selectedFile) {
                this.preview = await api.previewAmazonImport(this.selectedFile);
            }
        },
        money(amount: number): string {
            return visualizeAmount(amount);
        },
        formatDate(date: string): string {
            return formatDate(new Date(date));
        },
        candidateText(candidate: AmazonExpenseCandidate): string {
            return `#${candidate.id} · ${this.formatDate(candidate.date)} · ${this.money(candidate.amount)} · ${candidate.reference || "no ref"}`;
        },
        matchText(match: AmazonExpenseMatch): string {
            return `${match.matchType} · ${this.money(match.amountCents)} · ${this.candidateText(match.expense)}`;
        }
    }
})
